/**
 * This enum is used for the health-check information
 */
export enum ChatbotHealthCheckEnum {
  OK = 'OK',
  KO = 'KO',
  ERROR = 'ERROR',
  DISABLED = 'DISABLED'
}
